<i18n>
{
    "ru": {
        "reset": "Сбросить все",
        "show":  "Показать",
        "showed":  "Показано",
        "no-results": "Нет результатов"
    }
}
</i18n>
<template>
    <div class="cat-filter"
        :class="{'cat-filter_with-result': !!count.result || !!count.timeout}">
        <slot name="body"></slot>

        <div class="cat-filter__count"
            v-sticky="true"
            sticky-side="bottom"
            data-fixed="true"
            :data-visible="!!count.result || !!count.timeout">
            <ButtonReset
                @click.native="$emit('resetAll')"
                class="cat-filter__reset">
                {{ $t('reset') }}
            </ButtonReset>
            <span class="btn btn_inner-loading btn_primary cat-filter__submit"
                :data-loading="count.loading"
                :data-disabled="!(count.result && count.result.total > 0) || submitted || count.loading"
                @click="submit">
                {{ submitText }}
            </span>
        </div>
    </div>
</template>

<script>
import ButtonReset from '@/components/ui/buttons/ButtonReset';

export default {
    name: 'CatalogFilter',
    components: {
        ButtonReset
    },
    props: {
        stickyCount: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            count: {
                timeout: false,
                request: null,
                loading: false,
                result: null
            },
            submitted: false
        }
    },
    computed: {
        submitText() {
            if (this.count.loading) {
                return '';
            }

            const counter = this.count.result 
                ? this.$options.filters.numberDeclension(this.count.result.total, this.$parent.countDeclensions)
                : '';

            if (this.submitted) {
                return this.$t('showed') + ' ' + counter;
            }
            
            if (this.count.result) {
                if (this.count.result.total < 1) {
                    return this.$t('no-results');
                }

                return this.$t('show') + ' ' + counter;
            }
            return '';
        }
    },
    globalBus: {
        'CatalogFilter::changed'(values) {

            !this.count.timeout || clearTimeout(this.count.timeout);

            this.count.loading = true;
            this.submitted = false;
            this.$bus.$emit('CatalogFilter::count', {loading: true});

            this.count.timeout = setTimeout(() => {

                !this.count.request || this.count.request.cancel();

                this.count.request = this.$api.CancelToken.source();
                this.$api.get(this.$parent.countUrl(), {cancelToken: this.count.request.token})
                    .then((response) => {
                        this.count.result = response.data;
                    })
                    .finally(() => {
                        this.count.request = null;
                        this.count.loading = false;
                        this.$bus.$emit('CatalogFilter::count', {loading: false, result: this.count.result});
                    });
            }, 500);
        },
        'CatalogFilter::reset'() {
            this.$parent.resetAll();
        }
    },
    methods: {
        submit() {
            if (this.count.result) {
                this.$emit('submit', {
                    values: this.$parent.values,
                    total: this.count.result.total,
                    url: this.$options.filters.urlRelative(this.count.result.htmlUrl)
                });
                this.submitted = true;
            }
        },
        hideCount() {
            this.count.result = null;
            !this.count.timeout || clearTimeout(this.count.timeout);
            !this.count.request || this.count.request.cancel();
            this.count.timeout = false;
        }
    }
}
</script>

<style lang="less">
.cat-filter{
    position: relative;

    &__count{
        background: @color-white;
        text-align: center;
        box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
        padding: rem(20);
        position: absolute;
        bottom: rem(10);
        width: rem(300);
        z-index: 10;
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
        .animate(opacity);

        &[data-fixed="true"]{
            position: fixed;
        }

        &[data-visible="true"] {
            opacity: 1;
            pointer-events: auto;
            visibility: visible;
        }
    }

    .vue-sticky-placeholder{
        margin-top: rem(20);
    }

    &__reset{
        &.button-reset{
            display: inline-block;
        }
    }

    @{desktop} & {
        &__submit{
            font-weight: 500;
            display: block;
            margin-top: rem(18);
        }
    }

    @{mobile} & {
        &__submit{
            font-weight: 500;
            display: block;
        }
    }

    &_modal{
        overflow-x: hidden;

        &.cat-filter_with-result{
            padding-bottom: rem(90);
        }

        .cat-filter__count{
            position: fixed!important;
            bottom: 0!important;
            right: 0!important;

            @{mobile} &{
                left: 0!important;
            }
        }

        .vue-sticky-placeholder{
            display: none;
        }
        
        @{mobile} &{
            background-color: @color-bg-gray;
            position: relative;

            .cat-filter-block{
                margin-top: rem(16);
                &:first-child{
                    margin-top: 0;
                    // padding-top: rem(16);
                }
            }
        }

        @{desktop} & {
            .search__input {
                border: 0;
                border-bottom: rem(1) solid @color-gray-white;
                border-top: rem(1) solid @color-gray-white;
                border-radius: 0;
                background-color: @color-bg-gray-minor;
                font-size: rem(15);
                padding-right: rem(8);
                padding-left: rem(48);
                .wi(search, 16, 16, 14, 20);

                .hover({
                    border-color: @color-gray-white;
                });
            }

            .cat-filter__count{
                width: rem(375)!important;
            }
        }

        .cat-filter-block{
            padding-left: rem(20);
            padding-right: rem(20);

            &:first-child{
                margin-top: 0;
            }
        }

        .cat-filter-block__head{
            font-size: rem(18);
        }

        .search__input{
            border-top: rem(1) solid @color-gray-white;
        }
        .search-field__form{
            margin-left: rem(-20);
            margin-right: rem(-20);
        }

        .cat-filter__reset{
            display: none;
        }

        .cat-filter__submit{
            @{desktop} & {
                margin-top: 0;
            }
            display: block;
        }
    }
}
</style>